import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// ------------------ Action Types ------------------
export const FETCH_DASHBOARD_REQUEST = "FETCH_DASHBOARD_REQUEST";
export const FETCH_DASHBOARD_SUCCESS = "FETCH_DASHBOARD_SUCCESS";
export const FETCH_DASHBOARD_FAILURE = "FETCH_DASHBOARD_FAILURE";

export const FETCH_DASHBOARD_OVERVIEW_REQUEST = "FETCH_DASHBOARD_OVERVIEW_REQUEST";
export const FETCH_DASHBOARD_OVERVIEW_SUCCESS = "FETCH_DASHBOARD_OVERVIEW_SUCCESS";
export const FETCH_DASHBOARD_OVERVIEW_FAILURE = "FETCH_DASHBOARD_OVERVIEW_FAILURE";

export const FETCH_PAPER_ATTENDANCE_REQUEST = "FETCH_PAPER_ATTENDANCE_REQUEST";
export const FETCH_PAPER_ATTENDANCE_SUCCESS = "FETCH_PAPER_ATTENDANCE_SUCCESS";
export const FETCH_PAPER_ATTENDANCE_FAILURE = "FETCH_PAPER_ATTENDANCE_FAILURE";

export const FETCH_STUDENT_OVERVIEW_REQUEST = "FETCH_STUDENT_OVERVIEW_REQUEST";
export const FETCH_STUDENT_OVERVIEW_SUCCESS = "FETCH_STUDENT_OVERVIEW_SUCCESS";
export const FETCH_STUDENT_OVERVIEW_FAILURE = "FETCH_STUDENT_OVERVIEW_FAILURE";

// ------------------ Dashboard Metrics (totals only) ------------------
export const fetchDashboardTotals = () => async (dispatch) => {
  dispatch({ type: FETCH_DASHBOARD_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/dashboard`, {
      headers: { Authorization: token },
    });

    dispatch({
      type: FETCH_DASHBOARD_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_DASHBOARD_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// ------------------ Dashboard Overview (totals + weekly trend) ------------------
export const fetchDashboardOverview = () => async (dispatch) => {
  dispatch({ type: FETCH_DASHBOARD_OVERVIEW_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/dashboardOverview`, {
      headers: { Authorization: token },
    });

    dispatch({
      type: FETCH_DASHBOARD_OVERVIEW_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_DASHBOARD_OVERVIEW_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// ------------------ Paper-wise Attendance ------------------
export const fetchPaperAttendance = () => async (dispatch) => {
  dispatch({ type: FETCH_PAPER_ATTENDANCE_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/paper-attendance`, {
      headers: { Authorization: token },
    });

    dispatch({
      type: FETCH_PAPER_ATTENDANCE_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PAPER_ATTENDANCE_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// ------------------ Student Attendance Overview (with pagination) ------------------
export const fetchStudentAttendanceOverview = (page = 1, limit = 10) => async (dispatch) => {
  dispatch({ type: FETCH_STUDENT_OVERVIEW_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/admin/student-attendance-overview?page=${page}&limit=${limit}`,
      { headers: { Authorization: token } }
    );

    dispatch({
      type: FETCH_STUDENT_OVERVIEW_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_STUDENT_OVERVIEW_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};